<div class="insta-widget">
  @if (profile()) {
    <a
      href="https://www.instagram.com/klondike.com.ua/"
      target="_blank"
      rel="noreferrer noopener"
    >
      <div class="insta-widget-header">
        <div class="insta-widget-profile">
          <div class="insta-widget-profile-avatar-wrap">
            <img
              class="insta-widget-profile-avatar"
              src="../../../assets/images/ig_logo.png"
              alt="Інстаграм"
            >
          </div>
          <div class="insta-widget-profile-login">{{ profile().username }}</div>
        </div>
        <div class="insta-widget-header-btn">
          <a class="insta-widget-view-profile-btn">{{ 'instagram_widget.go_to' | translate }}</a>
        </div>
      </div>
    </a>
  }

  @if (media().length) {
    <ul class="insta-widget-items">
      @for (post of media(); track post.id; let i = $index) {
        <li
          class="insta-widget-item"
          [class]="'insta-widget-item-' + i"
        >
          <a
            class="insta-widget-post"
            [href]="post.permalink"
            target="_blank"
            rel="noreferrer noopener"
          >
            <img
              class="insta-widget-post-img"
              [src]="setPostUrl(post)"
              [alt]="'Інстаграм пост - ' + post.caption"
            >
            @switch (post.media_type) {
              @case (mediaType.Carousel) {
                <svg
                  class="insta-widget-post-icon"
                  fill="#ffffff"
                  height="22"
                  role="img"
                  viewBox="0 0 48 48"
                  width="22"
                >
                  <path d="M34.8 29.7V11c0-2.9-2.3-5.2-5.2-5.2H11c-2.9 0-5.2 2.3-5.2 5.2v18.7c0 2.9 2.3 5.2 5.2 5.2h18.7c2.8-.1 5.1-2.4 5.1-5.2zM39.2 15v16.1c0 4.5-3.7 8.2-8.2 8.2H14.9c-.6 0-.9.7-.5 1.1 1 1.1 2.4 1.8 4.1 1.8h13.4c5.7 0 10.3-4.6 10.3-10.3V18.5c0-1.6-.7-3.1-1.8-4.1-.5-.4-1.2 0-1.2.6z" />
                </svg>
              }
              @case (mediaType.Video) {
                <svg
                  class="insta-widget-post-icon"
                  aria-label="Video"
                  color="#ffffff"
                  fill="#ffffff"
                  height="18"
                  role="img"
                  viewBox="0 0 48 48"
                  width="18"
                >
                  <path d="M9.6 46.5c-1 0-2-.3-2.9-.8-1.8-1.1-2.9-2.9-2.9-5.1V7.3c0-2.1 1.1-4 2.9-5.1 1.9-1.1 4.1-1.1 5.9 0l30.1 17.6c1.5.9 2.3 2.4 2.3 4.1 0 1.7-.9 3.2-2.3 4.1L12.6 45.7c-.9.5-2 .8-3 .8z" />
                </svg>
              }
            }
            <div
              class="insta-widget-post-modal"
              [class.insta-widget-post-modal-large]="i === 0"
            >
              <div
                class="insta-widget-post-modal-caption"
                [class.insta-widget-post-modal-caption-large]="i === 0"
              >
                <div class="insta-widget-post-modal-text">{{ post.caption }}</div>
              </div>
            </div>
          </a>
        </li>
      }
    </ul>
  }
</div>
